import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { TranslateLoader, TranslationObject } from '@ngx-translate/core';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TranslationHttpLoader extends TranslateLoader {
  private readonly httpClient = inject(HttpClient);

  getTranslation(language: string): Observable<TranslationObject> {
    return this.httpClient.get<TranslationObject>(`assets/i18n/${language}.json`);
  }
}
